import AddBankAccountForm from 'payments/components/AddBankAccountForm.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import DepositSetupViewHeader from './DepositSetupViewHeader.jsx';
import EventTrackingConstants from '../constants/EventTrackingConstants';
import trackView from 'lib/trackView';
import React, { PropTypes } from 'react';
import { TreasurerAddBankAccount as TreasurerAddBankAccountConstants }
  from 'payments/constants/CopyConstants';

import './styles/TreasurerAddBankAccount.scss';

const UI_CONTEXT = 'treasurer_add_account_flow';

const TreasurerAddBankAccount = React.createClass({
  propTypes: {
    connectedBankAccount: PropTypes.instanceOf(ConnectedBankAccount),
    onBankAccountAdded: PropTypes.func,
  },

  childContextTypes: {
    eventContextName: PropTypes.string,
    eventScreenName: PropTypes.string,
  },

  getChildContext() {
    return {
      eventContextName: UI_CONTEXT,
    };
  },

  onBankAccountAdded() {
    if (this.props.onBankAccountAdded) {
      this.props.onBankAccountAdded();
    }
  },

  render() {
    const subtext = `Your account and routing numbers will be kept private. You can revoke access
      at any time. By approving this request, you are only enabling ${this.props.connectedBankAccount.getConnectedUserName()} to deposit funds into
      this account.`;
    return (
      <CenteredContainer size="small" className="TreasurerAddBankAccount">
        <DepositSetupViewHeader
          title={TreasurerAddBankAccountConstants.title}
          subtext={subtext}
        />
        <AddBankAccountForm
          className="TreasurerAddBankAccount"
          onAdminBankAccountAdd={() => this.onBankAccountAdded()}
          connectedBankAccount={this.props.connectedBankAccount}
        />
      </CenteredContainer>
    );
  },
});

export default trackView(TreasurerAddBankAccount, EventTrackingConstants.TREASURER_ADD_BANK_ACCOUNT);



// WEBPACK FOOTER //
// ./src/payments/components/TreasurerAddBankAccount.jsx